var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoggedIn)?_c('nav-bar'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container-fluid pt-3"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }